import {ViewType} from "../../../gd/const/views/view-type";
import {NavigationSectionType} from "../../navigation/@const";

export default function getViewLocationOptions(type:ViewType):Option[] {

    let res: (Option | null)[]

    // console.green(type)
    // stupid konechno nado facotry bilo delat'
    switch (type) {

        case ViewType.MY_NOTES          :
        case ViewType.MY_TASKS_LIST     :
        case ViewType.MY_WORK_CALENDAR  :
        case ViewType.MY_DOCUMENTS      :
        case ViewType.MY_TIME           :
        case ViewType.MY_RECENT         :
        case ViewType.MY_WORK           :
        case ViewType.NOTIFICATIONS     :
        case ViewType.MY_WORK_WORKLOAD  :
        case ViewType.MY_MEETINGS       :
        case ViewType.MY_GOALS          :
            res = [
                {label: "Home Menu", value: NavigationSectionType.HOME, icon: 'i5-nav-home'},
                {label: "Navigation Panel", value: NavigationSectionType.NAVIGATION_PANEL, icon :'i5-panel'},
                // {label: "Navigation More", value: NavigationSectionType.MORE, icon: 'i5-more'},
            ]
            break

        case ViewType.MY_ATTENDANCE:
            res = [
                {label: "Navigation Panel", value: NavigationSectionType.NAVIGATION_PANEL, icon :'i5-panel'}
            ]
            break

        case ViewType.PROJECTS_PORTFOLIO:
            res = [
                {label: "Home Menu", value: NavigationSectionType.HOME, icon: 'i5-nav-home'},
                gd.spaces.projects.enabled ? {label: "Projects Menu", value: NavigationSectionType.PROJECTS, icon: 'i5-nav-projects'} : null,
                // {label: "Tools Menu", value: NavigationSectionType.TOOLS, icon: 'i5-nav-tools'},
                // {type: PopoverMenuItemType.SEPARATOR}
                // {label: "Navigation Panel", value: NavigationSectionType.NAVIGATION_PANEL, icon :'i5-panel'},
                // {label: "Navigation More", value: NavigationSectionType.MORE, icon: 'i5-more'},
            ]
            break

        // case ViewType.PROJECTS_PROJECTS_LIST:
        // case ViewType.PORTFOLIO_SUMMARY:
        //     return [
        //         {label: "Projects / Views", value: NavigationSectionType.PROJECTS},
        //     ]

        default:

            // console.log("Default locations....")

            res = [
                {label: "Home Menu", value: NavigationSectionType.HOME, icon: 'i5-nav-home'},
                gd.spaces.projects.enabled ? {label: "Projects Menu", value: NavigationSectionType.PROJECTS, icon: 'i5-nav-projects'} : null,
                // {label: "Tools Menu", value: NavigationSectionType.TOOLS, icon: 'i5-nav-tools'},
                // {type: PopoverMenuItemType.SEPARATOR}
                {label: "Navigation Panel", value: NavigationSectionType.NAVIGATION_PANEL, icon :'i5-panel'},
                // {label: "Navigation More", value: NavigationSectionType.MORE, icon: 'i5-more'},
            ]
            break
    }

    return _.compact(res) // compact removes empty items from array
}
